export default __webpack_public_path__ + "static/media/menu-2.d3d75e08.PNG";